var $8f872ea59c02d67e$exports = {};
$8f872ea59c02d67e$exports = {
  "colorInputLabel": function colorInputLabel(args) {
    return "".concat(args.label, ", ").concat(args.channelLabel);
  },
  "colorNameAndValue": function colorNameAndValue(args) {
    return "".concat(args.name, ": ").concat(args.value);
  },
  "colorPicker": "Seletor de cores",
  "colorSwatch": "amostra de cor",
  "transparent": "transparente",
  "twoDimensionalSlider": "Controle deslizante 2D"
};
export { $8f872ea59c02d67e$exports as default };